export default "/fonts/SegoeUI-Bold.woff?87be72ec72dbe2b0eebd51febb27699f";